import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-view-pdf-modal',
  templateUrl: './view-pdf-modal.component.html',
  styleUrls: ['./view-pdf-modal.component.scss']
})
export class ViewPdfModalComponent implements OnInit {
  pdfSrc
  public formData = {};

  constructor(
    public dialogRef: MatDialogRef<ViewPdfModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data,
  ) { }

  ngOnInit(): void {
    this.pdfSrc = this.data.pdf.fileUrl

    const applicant = this.data.applicant;
    this.formData = {
      date: new Date().toDateString().toUpperCase(),
      estab_address: this.data.application.occupationEstablishmentAddress
        .toString()
        .toUpperCase(),
      applicant_age: this.calculateAge(this.data.applicant.birthDate)
        .toString()
        .toUpperCase(),
      applicant_address:
        `${applicant.presentStreetName} ${applicant.presentBarangay} ${applicant.presentCity.name}`
          .toString()
          .toUpperCase(),
      applicant_ctc: this.data.application.officialReceipts
        .filter((e) => e.receiptType == 4)[0]
        ?.receiptNumber.toString()
        .toUpperCase(),
      ctc_date_issued: new Date(
        this.data.application.officialReceipts.filter(
          (e) => e.receiptType == 4
        )[0]?.dateIssued
      ),
      ctc_place_issued: "BAGUIO CITY",
      permit_no: this.data.application.apn.toString().toUpperCase(),
      applicant_name_a: this.data.application.applicantName
        .toString()
        .toUpperCase(),
      applicant_name_b: this.data.application.applicantName
        .toString()
        .toUpperCase(),
      occupation_a: this.data.application.occupation.toString().toUpperCase(),
      occupation_b: this.data.application.occupation.toString().toUpperCase(),
      estab_name_a: this.data.application.occupationEstablishment
        .toString()
        .toUpperCase(),
      estab_name_b: this.data.application.occupationEstablishment
        .toString()
        .toUpperCase(),
      year_a: new Date().getFullYear().toString().substring(2),
      year_b: new Date().getFullYear().toString().substring(2),
      day_month: new Date().toLocaleDateString(undefined, {
        month: "long",
        day: "numeric",
      }),
      or_no: this.data.application.officialReceipts
        .filter((e) => e.receiptType == 3)[0]
        ?.receiptNumber.toString()
        .toUpperCase(),
      ptr_no: this.data.application.officialReceipts
        .filter((e) => e.receiptType == 2)[0]
        ?.receiptNumber.toString()
        .toUpperCase(),
      sex: applicant.gender.toString().toUpperCase(),
      hso_engr: "",
      hso_officer: "",
      reg_no: "",
      address_street: applicant.presentStreetName,
      address_barangay: applicant.presentBarangay,
      address_city: applicant.presentCity.name
    };
  }

  calculateAge(birthdate: string): number {
    const birthDate = new Date(birthdate);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    // If the current month is before the birth month,
    // or it's the birth month but the day is yet to come, subtract one year from the age.
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

}
